/**
 * 实现元素在垂直方向的拖拽功能
 */
export const drag = {
  bind(el, binding) {
    // 获取拖动方向和点击事件
    const { direction = "vertical", click = () => {}, dragEl } = binding.value;
    // 注册鼠标按下事件方法
    el.onmousedown = (e) => {
      // 可拖拽目标元素
      const targetEl = dragEl || el;
      // 获取基础样式
      const style = window.getComputedStyle(targetEl);
      let top = getNumber(style.top) || 0;
      const maxTop =
        window.screen.availHeight -
        targetEl.clientHeight -
        targetEl.offsetHeight;
      // 创建mask
      const mask = document.createElement("div");
      const maskStyle = {
        position: "fixed",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: style.zIndex - 1,
      };
      Object.keys(maskStyle).forEach((key) => {
        mask.style[key] = maskStyle[key];
      });
      document.body.appendChild(mask);
      // 监听移动事件
      document.onmousemove = (e1) => {
        e1?.stopPropagation?.();
        e1?.preventDefault?.();
        // 计算元素位置
        const { movementY } = e1;
        if (direction === "vertical") {
          top += movementY;
          if (top < 40 || top > maxTop) {
            return;
          }
          targetEl.style.top = `${top}px`;
          targetEl.style.bottom = "auto";
        }
      };
      // 监听移动事件
      document.onmouseup = (e2) => {
        document.onmousemove = null;
        document.onmouseup = null;
        // 移除mask
        mask.parentNode.removeChild(mask);
        // 如果没有移动则发送点击事件
        if (e.clientX == e2.clientX && e.clientY == e2.clientY) {
          click();
        }
      };
    };
  },
};

const getNumber = (string = "") => {
  if (typeof string === "number") return string;
  return Number(string.split("p")[0]);
};
